<template>
  <div class="back-link" @click="$emit('click')">
    <v-icon color="primary" small>arrow_left</v-icon>
    Take me back to the current stage ({{ currentStage }})
  </div>
</template>

<script>
export default {
  name: 'BackLink',
  props: {
    currentStage: {
      type: String,
      required: true,
    },
  },
  emits: ['click'],
};
</script>

<style lang="scss" scoped>
.back-link {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;

  font-size: 10px;
  font-weight: 300;
  color: var(--v-primary-base);
  cursor: pointer;
}
</style>
